module.exports = __webpack_public_path__ + "static/img/landing.ea21b21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/landing.jpg
// module id = +bnW
// module chunks = 1